import { useState } from 'react';

import { BookingCalendly } from '@Components/Calendly';
import PhoneCallIcon from '@Components/Icons/PhoneCallIcon';

export const className = {
    //Loan preferences
    main_wrapper: 'mt-4 bg-white border rounded-lg',
    title: 'cursor-pointer flex justify-between items-center text-steel-100 font-bold px-4 py-3',
    additional_content: 'pl-1 ml-12',
    button_wrapper: 'flex w-full',
    call_us_btn:
        'cursor-pointer hover:bg-disabled flex-1 border-t border-r text-center p-4',
    schedule_btn:
        'cursor-pointer hover:bg-disabled flex-1 border-t border-l text-center px-2 py-4',

    //Other
    inner_phone_paragraph: 'text-base font-bold',
    schedule_paragragh: 'text-base ml-8',
    sm_inner_wrapper: 'flex items-center space-x-2',
};

export interface IPropsContactMenu {
    wrapperClassName: string;
}

export const ContactMenu = ({ wrapperClassName }: IPropsContactMenu) => {
    const [showCalendly, setShowCalendly] = useState<boolean>(false);

    const successNavLink =
        '/eligibility/loan-preferences/book-call/confirmation';

    return (
        <>
            <div className={wrapperClassName}>
                <div className={className.sm_inner_wrapper}>
                    <PhoneCallIcon />
                    <p className={className.inner_phone_paragraph}>
                        Need help?
                    </p>
                </div>
                <p className={className.schedule_paragragh}>
                    020 4525 8044 (Mon - Fri, 9am - 5pm)
                </p>
            </div>

            {showCalendly && (
                <BookingCalendly
                    successNavLink={successNavLink}
                    onClose={() => setShowCalendly(false)}
                />
            )}
        </>
    );
};
